import React from 'react';
import { Link } from 'react-router-dom';
import './travel.css';

const TravelPage = () => {
    return (
        <div className="travel-page">
            <h2>Travel</h2>
            <p>Quick access to listing and trip tools.</p>
            <div className="travel-links">
                <Link className="btn-primary" to="/Listings">Open Listings</Link>
                <Link className="btn-primary" to="/Trips">Open Trips</Link>
            </div>
        </div>
    );
};

export default TravelPage;
